import { useNavigate } from "react-router-dom";
import { Row, ContentCard, Button, ResponsiveFlex } from "@narmi/design_system";
import { useLocalization } from "@fluent/react";
import { entities, modules, cents } from "byzantine";
import filters from "byzantine/src/filters";
import { Features } from "byzantine/src/Feature";
import { useIsACHDualApprovalRequired } from "byzantine/src/dbbl/businessLogic/entities/users/hooks";
import { useUserFeatures } from "../../contexts/UserFeaturesContext";
import { ACH_PAYMENT_ROUTE } from "./ACHPaymentRoutes";
import styles from "./ReceiptScreen.module.scss";

const ReceiptScreen = () => {
  const { l10n } = useLocalization();
  const navigate = useNavigate();
  const features = useUserFeatures() as Features;
  const form = modules.achPayments.ACHPaymentForm.useForm();
  const selectedRecipient = entities.recipients.useSelectedRecipient();
  const achDualApprovalRequired = useIsACHDualApprovalRequired();
  const { ach_payments_scheduled: achScheduledEnabled } = features;
  const { resetForm } = form;

  if (!selectedRecipient) return null;

  const {
    values: { amount, recurringRule },
  } = form;
  const { name } = selectedRecipient;

  const handleClickDone = () => {
    window.location.assign("/");
  };

  const handleClickCTA = () => {
    resetForm();
    navigate(`/${ACH_PAYMENT_ROUTE}`);
  };

  const displayFrequency =
    achScheduledEnabled && recurringRule?.frequency && recurringRule?.isVisible;

  return (
    <div className={styles.receiptContainer}>
      <ContentCard>
        <div className={styles.cardContainer}>
          <h3 className="fontColor--heading">
            {achDualApprovalRequired
              ? l10n.getString("ach-payment-receipt-dual-approval-title")
              : l10n.getString("ach-payment-receipt-title")}
            <i className="narmi-icon-check margin--left--xs" />
          </h3>
          <div className={styles.contentContainer}>
            <ResponsiveFlex gapSize="l">
              <Row>
                <Row.Item>
                  <p>{l10n.getString("label-to")}</p>
                </Row.Item>
                <Row.Item shrink>
                  <p>{name}</p>
                </Row.Item>
              </Row>
              <Row>
                <Row.Item>
                  <p>{l10n.getString("label-amount")}</p>
                </Row.Item>
                <Row.Item shrink>
                  <p>{`${filters.currency(cents(amount))}`}</p>
                </Row.Item>
              </Row>
              {displayFrequency ? (
                <Row>
                  <Row.Item>
                    <p>{l10n.getString("label-frequency")}</p>
                  </Row.Item>
                  <Row.Item shrink>
                    <p>{recurringRule.frequency}</p>
                  </Row.Item>
                </Row>
              ) : null}
              <Row>
                <Row.Item>
                  <p>{l10n.getString("label-delivery-speed")}</p>
                </Row.Item>
                <Row.Item shrink>
                  <p>{l10n.getString("ach-payment-receipt-delivery")}</p>
                </Row.Item>
              </Row>
            </ResponsiveFlex>
          </div>
          <div className={styles.buttonContainer}>
            <Button
              label={l10n.getString("label-done")}
              onClick={handleClickDone}
            />
            <Button
              kind="plain"
              label={l10n.getString("ach-payment-receipt-cta")}
              onClick={handleClickCTA}
            />
          </div>
        </div>
      </ContentCard>
    </div>
  );
};

export default ReceiptScreen;
